module.exports = __webpack_public_path__ + "static/img/Cardfooter09.213066b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter09.png
// module id = N0S6
// module chunks = 1